import { useEditorState } from '@tiptap/react';

const useTextMenuContentTypes = (editor) => useEditorState({
  editor,
  selector: (ctx) => [
    {
      type: 'category',
      label: 'Text Style',
      id: 'text-style',
    },
    {
      icon: 'Pilcrow',
      onClick: () => {
        ctx.editor
          .chain()
          .focus()
          .unsetFontSize()
          .run();
      },
      id: 'paragraph',
      label: 'Paragraph',
      type: 'option',
      disabled: () => false,
      isActive: () => {
        const fontSize = ctx.editor.getAttributes('textStyle')?.fontSize;
        return !fontSize || fontSize === '12px'; // also allow 12px to mean 'normal'
      },
    },

    {
      icon: 'Heading1',
      onClick: () => ctx.editor.chain().focus().setFontSize('32px').run(),
      id: 'heading1',
      label: 'Heading 1',
      type: 'option',
      disabled: () => false,
      isActive: () => ctx.editor.getAttributes('textStyle')?.fontSize === '32px',
    },
    {
      icon: 'Heading2',
      onClick: () => ctx.editor.chain().focus().setFontSize('24px').run(),
      id: 'heading2',
      label: 'Heading 2',
      type: 'option',
      disabled: () => false,
      isActive: () => ctx.editor.getAttributes('textStyle')?.fontSize === '24px',
    },
    {
      icon: 'Heading3',
      onClick: () => ctx.editor.chain().focus().setFontSize('18px').run(),
      id: 'heading3',
      label: 'Heading 3',
      type: 'option',
      disabled: () => false,
      isActive: () => ctx.editor.getAttributes('textStyle')?.fontSize === '18px',
    },
    {
      type: 'category',
      label: 'Lists',
      id: 'lists',
    },
    {
      icon: 'List',
      onClick: () => ctx.editor.chain().focus().toggleBulletList().run(),
      id: 'bulletList',
      disabled: () => !ctx.editor.can().toggleBulletList(),
      isActive: () => ctx.editor.isActive('bulletList'),
      label: 'Bullet list',
      type: 'option',
    },
    {
      icon: 'ListOrdered',
      onClick: () => ctx.editor.chain().focus().toggleOrderedList().run(),
      id: 'orderedList',
      disabled: () => !ctx.editor.can().toggleOrderedList(),
      isActive: () => ctx.editor.isActive('orderedList'),
      label: 'Numbered list',
      type: 'option',
    },
    {
      icon: 'ListTodo',
      onClick: () => ctx.editor.chain().focus().toggleTaskList().run(),
      id: 'todoList',
      disabled: () => !ctx.editor.can().toggleTaskList(),
      isActive: () => ctx.editor.isActive('taskList'),
      label: 'Todo list',
      type: 'option',
    },
  ],
});

export default useTextMenuContentTypes;
